import React from 'react';
import { Select as MuiSelect, MenuItem, withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import ChevronWhite from 'Assets/Images/chevron-down-ic.svg';
import ChevronBlue from 'Assets/Images/chevron-down-blue-ic.svg';
import styles from './Select.styles';
import ErrorLabel, { constants as labelConstants } from '../Label/ErrorLabel';

export const constants = {
  colorScheme: {
    white: 'white',
    lightBlue: 'lightBlue',
  },
};

class Select extends React.PureComponent {
  getStyleClasses() {
    const {
      colorScheme, classes, value, preventPlaceholder,
    } = this.props;

    if (colorScheme === constants.colorScheme.white) {
      return {
        input: classes.whiteInput,
        menu: classes.whiteMenu,
        label: classes.labelLight,
        chevron: ChevronWhite,
        errorColor: labelConstants.textColor.pink,
      };
    }

    const isPlaceholder = value === 0 && !preventPlaceholder;
    return {
      input: isPlaceholder ? classes.placeholder : classes.blueInput,
      menu: classes.blueMenu,
      label: classes.labelDark,
      chevron: ChevronBlue,
      errorColor: labelConstants.textColor.darkRed,
    };
  }

  onSelectionChange = ({ target: { value } }) => {
    this.props.onChange(value, this.props.id);
  }

  render() {
    const {
      classes,
      className,
      label,
      placeholder,
      data,
      value,
      id,
      error,
      preventPlaceholder,
      disabledPlaceholder,
    } = this.props;

    const styleClasses = this.getStyleClasses();

    return (
      <div className={className}>
        <div className={styleClasses.label}>{label}</div>
        <MuiSelect
          id={id}
          disableUnderline
          classes={{
            root: styleClasses.input,
            selectMenu: styleClasses.menu,
            select: classes.noPadding,
          }}
          fullWidth
          IconComponent={() => <img src={styleClasses.chevron} alt="Select" className={classes.icon} />}
          value={value}
          onChange={this.onSelectionChange}
          MenuProps={{
            MenuListProps: {
              className: classes.noPadding,
            },
          }}
        >
          <If condition={!preventPlaceholder && !disabledPlaceholder}>
            <MenuItem
              selected={false}
              value={0}
              className={classes.menuItem}
              classes={{ selected: classes.selected }}
            >
              {placeholder}
            </MenuItem>
          </If>
          <If condition={!preventPlaceholder && disabledPlaceholder}>
            <MenuItem
              selected={false}
              value={0}
              className={classes.menuItem}
              classes={{ selected: classes.selected }}
              disabled
            >
              {placeholder}
            </MenuItem>
          </If>
          {data.map((item) => {
            return (
              <MenuItem
                value={item.id}
                name={item.name}
                selected={false}
                className={classes.menuItem}
                classes={{ selected: classes.selected }}
                key={item.id}
              >
                {item.name}
              </MenuItem>
            );
          })}
        </MuiSelect>
        <ErrorLabel error={error} verticalPadding textColor={styleClasses.errorColor} />
      </div>
    );
  }
}
Select.defaultProps = {
  className: '',
  label: '',
  placeholder: '',
  data: [],
  error: '',
  preventPlaceholder: false,
  disabledPlaceholder: false,
  colorScheme: constants.colorScheme.white,
};

Select.propTypes = {
  id: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string]).isRequired, // unique identifying id
    name: PropTypes.string.isRequired, // Text to display in the dropdown
  })),
  placeholder: PropTypes.string,
  preventPlaceholder: PropTypes.bool,
  disabledPlaceholder: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array]).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  colorScheme: PropTypes.oneOf(Object.values(constants.colorScheme)),
};

export default compose(withStyles(styles), withTheme())(Select);
